module.exports = __webpack_public_path__ + "static/media/agua-partitura.eee81be3.png";